import { z } from 'zod'

export const backtestLastPricesRequestSchema = z.object({
  instrumentUids: z.array(z.string()).min(1).max(50),
})

export type BacktestLastPricesRequestDto = z.infer<typeof backtestLastPricesRequestSchema>

// response: map of instrumentUid → last price (currency units)
export type BacktestLastPricesDto = Record<string, number>
